//
// Action types
//

export const SET_DRAG_STATE = "SET_DRAG_STATE";

//
// Action creators
//

export function setDragState(dragState) {
  return {
    type: SET_DRAG_STATE,
    dragState
  };
}

function setDragStateHandler(state, dragState) {
  return { ...dragState };
}

//
// Reducer and handlers
//
export default function dragStatesReducer(state, action) {
  switch (action && action.type) {
    case SET_DRAG_STATE:
      return setDragStateHandler(state, action.dragState);

    default:
      return state || {};
  }
}
